module.exports = __webpack_public_path__ + "img/计划数@3x.a3006a22.png";